import React, { useState, useMemo, useContext, useEffect } from 'react';
import './news.scss';
import { AppContext } from '../../services/translationContext';
import { Link, useParams } from 'react-router-dom';
import { Loader } from '../../components/loader/loader';
import { PageHero } from '../../components/page-hero/page-hero';
import { EmotionalCard } from '../../components/cards/emotional-card';
import SeoHelmet from '../../components/SeoHelmet';

const api = process.env.REACT_APP_URL_API;
const pathUrl = process.env.REACT_APP_BASE_URL;

export const News = () => {
  const { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  const [newsList, setNewsList] = useState([]);
  const [pagingState, setPagingState] = useState('');
  const [showLoader, setShowLoader] = useState(false);

  const pageTitle = `Blog | ${TranslationsService.getMainInfoCompany('name')}`;
  const pageDescription = TranslationsService.labels('hero_sections.news.text');
  const pageUrl = `https://www.sydea.com/${lang}/insights/blog`;

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.insights.label`), item: `https://www.sydea.com/${lang}/insights` },
      { "@type": "ListItem", position: 3, name: "Blog", item: pageUrl }
    ]
  };

  const blogSchema = useMemo(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Sydea Blog",
      description: pageDescription,
      url: pageUrl,
      inLanguage: lang === 'it' ? 'it-IT' : 'en-US',
      mainEntity: {
        "@id": "https://www.sydea.com/#organization"
      }
    };

    if (newsList?.length > 0) {
      schema.blogPost = newsList.map((news) => ({
        "@type": "BlogPosting",
        headline: news.title,
        url: `https://www.sydea.com/${lang}/insights/blog/${news.id}`
      }));
    }

    return schema;
  }, [newsList, lang, pageDescription, pageUrl]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(
          `${pathUrl}/static/content/blog.json?_cache_buster=${Date.now()}`
        );
        const data = await response.json();
        setNewsList(data[lang]);
      } catch (error) {
        console.error("Errore nel caricamento del blog:", error);
      }
    };
    fetchNews();
  }, [pathUrl]);

  const showMoreNews = () => {
    setShowLoader(true);
    fetch(`${api}/content-public?id=news&language=${TranslationsService.getCurrentLanguage()}&paging_state=${pagingState}`)
      .then(response => response.json()).then(data => {          
        let _listEl = [...newsList];
        _listEl = [..._listEl,...data.data]
        setNewsList(_listEl);
        setPagingState(data.paging_state);
        setShowLoader(false);
      });
  }

  return (
    <div id='container-news' className="section-home light pb-3">

      <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels('hero_sections.news.img_path')}
        schema={[blogSchema, breadcrumbSchema]}
      />

      <PageHero 
        bgImage={TranslationsService.labels('hero_sections.news.img_path')}
        breadcrumb={[
          { label: TranslationsService.labels(`menu.insights.label`), path: 'insights' }
        ]}
        title='Blog'
        subtitle={TranslationsService.labels(`hero_sections.news.text`)}
      />

      {
        showLoader &&
        <Loader />
      }

      <div className='p-3 d-flex flex-column'>
        <div className='row gap-3 gap-lg-0'>
        {
          newsList?.length > 0 &&
          newsList.map((news, ind) => (
            <EmotionalCard 
              key={ind}
              colMD={3}
              colSM={12}
              title={news.title} link={`/${lang}/insights/blog/${news.id}`} 
              bgImage={news.image_url}
              category={news.category}
              desc={news.desc}
            />
          ))
        }
        </div>
      </div>
      
      {
        pagingState &&
        <div className='news-btn-more py-3 px-5 m-auto text-uppercase transition-03s-eio d-flex align-items-center gap-1' onClick={showMoreNews}>
          Show more
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
          </svg>
        </div>
      }

    </div>
  );
};